import {action, observable} from "mobx";

import companyService from "../services/companyService";
import appStore from "./appStore";
import meStore from "./meStore";
import config from "../_core/config";
import {b64DecodeToUrl} from "../utils/helpers";
import i18n from "../i18n";
import logoService from "../services/logoService";

class companyStore {
    @observable subCompanies;
    @observable subArray;
    @observable subCompanyList = [];

    @action getSubCompanyCaris = async params => {
        const resultOfRequest = await companyService.getSubCompanyCaris(params);
        return resultOfRequest;
    };

    @action getCompanyList = async params => {
        const resultOfRequest = await companyService.getCompanyList(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };
    @action getFalseCompanyRecordList = async params => {
        const resultOfRequest = await companyService.getFalseCompanyRecordList(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };
    @action getCompanies = async params => {
        const resultOfRequest = await companyService.getCompanies(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action getSubCompanyList = async params => {
        const resultOfRequest = await companyService.getSubCompanyList(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        this.subCompanyList = resultOfRequest?.data?.rows?.filter(sC => !sC?.disabled) || [];
        return resultOfRequest.data;
    };

    @action getSubcompanyPageList = async params => {
        const resultOfRequest = await companyService.getSubcompanyPageList(params);
        return resultOfRequest;
    };

    @action getSubcompanyUsers = async params => {
        const resultOfRequest = await companyService.getSubcompanyUsers(params);
        return resultOfRequest;
    };

    @action getSubcompanyDetail = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await companyService.getSubcompanyDetail(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action updateSubcompanyDetail = async params => {
        const resultOfRequest = await companyService.updateSubcompanyDetail(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action getSubcompanyContracts = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await companyService.getSubcompanyContracts(params);
        await appStore.setLoading(false);
        return resultOfRequest;
    };

    @action getCompany = async params => {
        const resultOfRequest = await companyService.getCompany(params);
        if (resultOfRequest.data.photo) {
            resultOfRequest.data.photoId = resultOfRequest.data.photo;
            resultOfRequest.data.photo = `${config.getBasePublicUrl()}api/panel/v1/image/${
                resultOfRequest.data.photo
            }`;
        }
        if (resultOfRequest.data.markerImage) {
            resultOfRequest.data.markerImageSrc = `${config.getBasePublicUrl()}api/panel/v1/image/${
                resultOfRequest.data.markerImage
            }`;
        }
        return resultOfRequest;
    };

    @action getSubCompany = async params => {
        const resultOfRequest = await companyService.getSubCompany(params);
        if (resultOfRequest.data.photo) {
            resultOfRequest.data.photoId = resultOfRequest.data.photo;
            resultOfRequest.data.photo = `${config.getBasePublicUrl()}api/panel/v1/image/${
                resultOfRequest.data.photo
            }`;
        }
        return resultOfRequest;
    };

    @action getSubCompanyPaymentContracts = async params => {
        const resultOfRequest = await companyService.getSubCompanyPaymentContracts(params);
        return resultOfRequest;
    };

    @action getSubCompanyPaymentTransactionLogList = async params => {
        const resultOfRequest = await companyService.getSubCompanyPaymentTransactionLogList(params);
        return resultOfRequest;
    };

    @action getSubCompanyPaymentTransactionLogForClient = async params => {
        const resultOfRequest = await companyService.getSubCompanyPaymentTransactionLogForClient(
            params
        );
        return resultOfRequest;
    };

    @action getCompanyCariRecords = async params => {
        const resultOfRequest = await companyService.getCompanyCariRecords(params);
        return resultOfRequest;
    };

    @action getCompanyCariLogs = async params => {
        const resultOfRequest = await companyService.getCompanyCariLogs(params);
        return resultOfRequest;
    };

    @action downloadInvoice = async params => {
        const resultOfRequest = await logoService.downloadInvoice(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action createSubCompanyPaymentContract = async params => {
        const resultOfRequest = await companyService.createSubCompanyPaymentContract(params);
        return resultOfRequest;
    };

    @action generateCompanyCode = async () => {
        const resultOfRequest = await companyService.generateCompanyCode();
        if (resultOfRequest.status === 200) return resultOfRequest.data;
        return false;
    };

    @action generateSubcompanyCode = async params => {
        const resultOfRequest = await companyService.generateSubCompanyCode(params);
        if (resultOfRequest.status === 200) return resultOfRequest.data.subCompanyCode;
        return resultOfRequest;
    };

    @action getSubCompanyByRegionIds = async params => {
        const resultOfRequest = await companyService.getSubCompanyByRegionIds(params);
        return resultOfRequest;
    };

    @action createCompany = async params => {
        const resultOfRequest = await companyService.createCompany(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }

        appStore.showSuccessMessage({
            content: i18n.t("stores.company.createCompany.successMessage", {ns: "common"})
        });
        appStore.getCompanyUserList();
        return resultOfRequest.data;
    };
    @action createSubCompany = async params => {
        const resultOfRequest = await companyService.createSubCompany(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }

        appStore.showSuccessMessage({
            content: i18n.t("stores.company.createSubCompany.successMessage", {ns: "common"})
        });
        appStore.getCompanyUserList();
        return resultOfRequest.data;
    };
    @action updateCompany = async params => {
        const resultOfRequest = await companyService.updateCompany(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        if (meStore.checkRole("isCompanyUser")) {
            meStore.setCompany({
                companyName: params.companyName,
                photo: params.photo,
                _id: params._id
            });
        }
        appStore.showSuccessMessage({
            content: i18n.t("stores.company.updateCompany.successMessage", {ns: "common"})
        });
        appStore.getCompanyUserList();
        return true;
    };

    //TODO Options fonksiyonlari tek bir fonsiyona cekilebilir.

    @action updateCompanyMergeOptions = async params => {
        const resultOfRequest = await companyService.updateCompanyMergeOptions(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        if (meStore.checkRole("isCompanyUser")) {
            meStore.setCompany({
                companyName: params.companyName,
                photo: params.photo,
                _id: params._id
            });
        }
        appStore.showSuccessMessage({
            content: i18n.t("stores.company.updateCompanyMergeOptions.successMessage", {
                ns: "common"
            })
        });
        appStore.getCompanyUserList();
        return true;
    };

    @action updateCompanyQueueOptions = async params => {
        const resultOfRequest = await companyService.updateCompanyQueueOptions(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        if (meStore.checkRole("isCompanyUser")) {
            meStore.setCompany({
                companyName: params.companyName,
                photo: params.photo,
                _id: params._id
            });
        }
        appStore.showSuccessMessage({
            content: i18n.t("stores.company.updateCompanyQueueOptions.successMessage", {
                ns: "common"
            })
        });
        appStore.getCompanyUserList();
        return true;
    };

    @action updateCompanyDistanceNotificationOptions = async params => {
        const resultOfRequest = await companyService.updateCompanyDistanceNotificationOptions(
            params
        );
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        if (meStore.checkRole("isCompanyUser")) {
            meStore.setCompany({
                companyName: params.companyName,
                photo: params.photo,
                _id: params._id
            });
        }
        appStore.showSuccessMessage({
            content: i18n.t(
                "stores.company.updateCompanyDistanceNotificationOptions.successMessage",
                {
                    ns: "common"
                }
            )
        });
        appStore.getCompanyUserList();
        return true;
    };

    @action updateCompanyProofOfDelivery = async params => {
        const resultOfRequest = await companyService.updateCompanyProofOfDelivery(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        if (meStore.checkRole("isCompanyUser")) {
            meStore.setCompany({
                companyName: params.companyName,
                photo: params.photo,
                _id: params._id
            });
        }
        appStore.showSuccessMessage({
            content: i18n.t("stores.company.updateCompanyProofOfDelivery.successMessage", {
                ns: "common"
            })
        });
        appStore.getCompanyUserList();
        return true;
    };

    @action updateCompanyTrackingOptions = async params => {
        const resultOfRequest = await companyService.updateCompanyTrackingOptions(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        if (meStore.checkRole("isCompanyUser")) {
            meStore.setCompany({
                companyName: params.companyName,
                photo: params.photo,
                _id: params._id
            });
        }
        appStore.getCompanyUserList();
        appStore.showSuccessMessage({
            content: i18n.t("stores.company.updateCompanyTrackingOptions.successMessage", {
                ns: "common"
            })
        });
        return true;
    };

    @action updateCompanyBarcodeOptions = async params => {
        const resultOfRequest = await companyService.updateCompanyBarcodeOptions(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        if (meStore.checkRole("isCompanyUser")) {
            meStore.setCompany({
                companyName: params.companyName,
                photo: params.photo,
                _id: params._id
            });
        }
        appStore.getCompanyUserList();
        appStore.showSuccessMessage({
            content: i18n.t("stores.company.updateCompanyBarcodeOptions.successMessage", {
                ns: "common"
            })
        });
        return true;
    };

    @action updateCompanyDynamicPriceOptions = async params => {
        const resultOfRequest = await companyService.updateCompanyDynamicPriceOptions(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        if (meStore.checkRole("isCompanyUser")) {
            meStore.setCompany({
                companyName: params.companyName,
                photo: params.photo,
                _id: params._id
            });
        }
        appStore.getCompanyUserList();
        appStore.showSuccessMessage({
            content: i18n.t("stores.company.updateCompanyDynamicPriceOptions.successMessage", {
                ns: "common"
            })
        });
        return true;
    };

    @action updateCompanyLocationCheckOptions = async params => {
        const resultOfRequest = await companyService.updateLocationCheckOptions(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        if (meStore.checkRole("isCompanyUser")) {
            meStore.setCompany({
                companyName: params.companyName,
                photo: params.photo,
                _id: params._id
            });
        }
        appStore.getCompanyUserList();
        appStore.showSuccessMessage({
            content: i18n.t("stores.company.updateCompanyLocationCheckOptions.successMessage", {
                ns: "common"
            })
        });
        return true;
    };

    @action updateCompanyVerificationOptions = async params => {
        const resultOfRequest = await companyService.updateCompanyVerificationOptions(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        if (meStore.checkRole("isCompanyUser")) {
            meStore.setCompany({
                companyName: params.companyName,
                photo: params.photo,
                _id: params._id
            });
        }
        appStore.getCompanyUserList();
        appStore.showSuccessMessage({
            content: i18n.t("stores.company.updateCompanyVerificationOptions.successMessage", {
                ns: "common"
            })
        });
        return true;
    };

    @action updateCompanySlotOrderOptions = async params => {
        const resultOfRequest = await companyService.updateCompanySlotOrderOptions(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        if (meStore.checkRole("isCompanyUser")) {
            meStore.setCompany({
                companyName: params.companyName,
                photo: params.photo,
                _id: params._id
            });
        }
        appStore.getCompanyUserList();
        appStore.showSuccessMessage({
            content: i18n.t("stores.company.updateCompanySlotOrderOptions.successMessage", {
                ns: "common"
            })
        });
        return true;
    };

    @action deleteCompany = async params => {
        const resultOfRequest = await companyService.deleteCompany(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: i18n.t("stores.company.deleteCompany.successMessage", {ns: "common"})
        });
        appStore.getCompanyUserList();
        return true;
    };

    @action getSubCompanyMapList = async params => {
        const resultOfRequest = await companyService.getSubCompanyMapList(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        }
        const companies = resultOfRequest.data.map(company => company);
        const companyName = resultOfRequest.data.map(company => company.name);
        this.subCompanies = companyName;
        this.subArray = companies;
        return resultOfRequest.data;
    };

    @action updateSubCompany = async params => {
        const resultOfRequest = await companyService.updateSubCompany(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: i18n.t("stores.company.updateSubCompany.successMessage", {ns: "common"})
        });
        return true;
    };

    @action updateSubCompanyAuthorizedID = async params => {
        const resultOfRequest = await companyService.updateSubCompanyAuthorizedID(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest.data;
        }
        return resultOfRequest.data;
    };

    @action changeSubCompanyOnboardingStatus = async params => {
        const resultOfRequest = await companyService.changeSubCompanyOnboardingStatus(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: i18n.t("stores.company.changeSubCompanyOnboardingStatus.successMessage", {
                ns: "common"
            })
        });
        return true;
    };

    @action updateCreditAlertLimit = async params => {
        const resultOfRequest = await companyService.updateCreditAlertLimit(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: "Kredi Uyarı Limiti Güncellendi"
        });
        return true;
    };

    @action updateMinCreditLoadLimit = async params => {
        const resultOfRequest = await companyService.updateMinCreditLoadLimit(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: "Minimum Kredi Yükleme Limiti Güncellendi"
        });
        return true;
    };

    @action updateSubCompanyStatus = async params => {
        const resultOfRequest = await companyService.updateSubCompanyStatus(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: i18n.t("stores.company.updateSubCompanyStatus.successMessage", {ns: "common"})
        });
        return true;
    };

    @action createObjectionsCreditLog = async params => {
        const resultOfRequest = await companyService.createObjectionsCreditLog(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: "İtiraz Oluşturuldu"
        });
        return true;
    };

    @action getObjectionsCreditLog = async params => {
        const resultOfRequest = await companyService.getObjectionsCreditLog(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action updateSubCompanyMergeOptions = async params => {
        const resultOfRequest = await companyService.updateSubCompanyMergeOptions(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: i18n.t("stores.company.updateSubCompanyMergeOptions.successMessage", {
                ns: "common"
            })
        });
        return true;
    };

    @action updateSubCompanyCredit = async params => {
        const resultOfRequest = await companyService.updateSubCompanyCredit(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: i18n.t("stores.company.updateSubCompanyCredit.successMessage", {
                ns: "common"
            })
        });
        return true;
    };

    @action approveObjection = async params => {
        const resultOfRequest = await companyService.approveObjection(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: "İtiraz Onaylandı"
        });
        return true;
    };

    @action rejectObjection = async params => {
        const resultOfRequest = await companyService.rejectObjection(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: "İtiraz Reddedildi"
        });
        return true;
    };

    @action updateSubCompanyQueueOptions = async params => {
        const resultOfRequest = await companyService.updateSubCompanyQueueOptions(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: i18n.t("stores.company.updateSubCompanyQueueOptions.successMessage", {
                ns: "common"
            })
        });
        return true;
    };

    @action updateSubCompanyDistanceNotificationOptions = async params => {
        const resultOfRequest = await companyService.updateSubCompanyDistanceNotificationOptions(
            params
        );
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: i18n.t(
                "stores.company.updateSubCompanyDistanceNotificationOptions.successMessage",
                {
                    ns: "common"
                }
            )
        });
        return true;
    };

    @action updateSubCompanyProofOfDelivery = async params => {
        const resultOfRequest = await companyService.updateSubCompanyProofOfDelivery(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: i18n.t("stores.company.updateSubCompanyProofOfDelivery.successMessage", {
                ns: "common"
            })
        });
        return true;
    };

    @action updateSubCompanyTrackingOptions = async params => {
        const resultOfRequest = await companyService.updateSubCompanyTrackingOptions(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: i18n.t("stores.company.updateSubCompanyTrackingOptions.successMessage", {
                ns: "common"
            })
        });
        return true;
    };

    @action updateSubCompanyDynamicPriceOptions = async params => {
        const resultOfRequest = await companyService.updateSubCompanyDynamicPriceOptions(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: i18n.t("stores.company.updateSubCompanyDynamicPriceOptions.successMessage", {
                ns: "common"
            })
        });
        return true;
    };

    @action updateSubCompanyVerificationOptions = async params => {
        const resultOfRequest = await companyService.updateSubCompanyVerificationOptions(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: i18n.t("stores.company.updateSubCompanyVerificationOptions.successMessage", {
                ns: "common"
            })
        });
        return true;
    };

    @action updateSubCompanySlotOrderOptions = async params => {
        const resultOfRequest = await companyService.updateSubCompanySlotOrderOptions(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: i18n.t("stores.company.updateSubCompanySlotOrderOptions.successMessage", {
                ns: "common"
            })
        });
        return true;
    };

    @action uploadImage = async params => {
        const resultOfRequest = await companyService.uploadImage(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }

        return resultOfRequest.data;
    };

    @action upload = async params => {
        const resultOfRequest = await companyService.upload(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }

        return resultOfRequest.data;
    };

    @action uploadMarkerImage = async params => {
        const resultOfRequest = await companyService.uploadMarkerImage(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }

        return resultOfRequest.data;
    };

    @action downloadSubCompanyExcelFile = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await companyService.downloadSubCompanyExcelFile(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return b64DecodeToUrl(resultOfRequest.data);
    };

    @action updateCutOffOptions = async params => {
        const resultOfRequest = await companyService.updateCutOffOptions(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: i18n.t("stores.company.updateCompanyCutOffOptions.successMessage", {
                ns: "common"
            })
        });
        return true;
    };

    @action updateShiftSuggestionOptions = async params => {
        const resultOfRequest = await companyService.updateShiftSuggestionOptions(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        if (meStore.checkRole("isCompanyUser")) {
            meStore.setCompany({
                companyName: params.companyName,
                photo: params.photo,
                _id: params._id
            });
        }
        appStore.getCompanyUserList();
        appStore.getCompanyUserList();
        appStore.showSuccessMessage({
            content: i18n.t("stores.company.updateShiftSuggestionOptions.successMessage", {
                ns: "common"
            })
        });
        return true;
    };

    @action sendApiGuidelineEmail = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await companyService.sendApiGuidelineEmail(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action listPayments = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await companyService.listPayments(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }

        return resultOfRequest.data;
    };

    //#region Platform Integrations
    @action listSubcompanyIntegrationsFields = async () => {
        const resultOfRequest = await companyService.listSubcompanyIntegrationsFields();
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action listSubcompanyIntegrations = async params => {
        const resultOfRequest = await companyService.listSubcompanyIntegrations(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action createSubcompanyIntegration = async params => {
        const resultOfRequest = await companyService.createSubcompanyIntegration(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action updateSubcompanyIntegration = async params => {
        const resultOfRequest = await companyService.updateSubcompanyIntegration(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action deleteSubcompanyIntegration = async params => {
        const resultOfRequest = await companyService.deleteSubcompanyIntegration(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action healthCheckSubcompanyIntegration = async params => {
        const resultOfRequest = await companyService.healthCheckSubcompanyIntegration(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action listIntegrationsPaymentTypes = async () => {
        const resultOfRequest = await companyService.listIntegrationsPaymentTypes();
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };
    //#endregion

    //#region Meal Card Integrations
    @action listSubcompanyMealCardIntegrationsFields = async () => {
        const resultOfRequest = await companyService.listSubcompanyMealCardIntegrationsFields();
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action listSubcompanyMealCardIntegrations = async params => {
        const resultOfRequest = await companyService.listSubcompanyMealCardIntegrations(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action createSubcompanyMealCardIntegration = async params => {
        const resultOfRequest = await companyService.createSubcompanyMealCardIntegration(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action updateSubcompanyMealCardIntegration = async params => {
        const resultOfRequest = await companyService.updateSubcompanyMealCardIntegration(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action deleteSubcompanyMealCardIntegration = async params => {
        const resultOfRequest = await companyService.deleteSubcompanyMealCardIntegration(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action createPaymentLink = async params => {
        const resultOfRequest = await companyService.createPaymentLink(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };
    //#endregion

    @action getSubCompanySalesReport = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await companyService.getSubCompanySalesReport(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        }
        return b64DecodeToUrl(resultOfRequest.data);
    };

    @action updateSubCompanyCodPaymentSettings = async params => {
        const resultOfRequest = await companyService.updateSubCompanyCodPaymentSettings(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({
                content: resultOfRequest?.data?.error || resultOfRequest?.data?.message
            });
            return false;
        }
        appStore.showSuccessMessage({
            content: "Kapıda Ödeme Ayarları Güncellendi"
        });
        return resultOfRequest.data;
    };

    @action updateSubcompanyPaymentInfo = async params => {
        const resultOfRequest = await companyService.updateSubcompanyPaymentInfo(params);
        console.log("resultOfRequest", resultOfRequest);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({
                content: resultOfRequest?.data?.error || resultOfRequest?.data?.message
            });
            return false;
        }
        return resultOfRequest.data;
    };

    @action updateSubCompanyReadyOrderNotificationSettings = async params => {
        const resultOfRequest = await companyService.updateSubCompanyReadyOrderNotificationSettings(
            params
        );
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action transferSubcompanyToAnotherCompany = async params => {
        const resultOfRequest = await companyService.transferSubcompanyToAnotherCompany(params);
        if (resultOfRequest.status !== 200 || !resultOfRequest.data.success) {
            appStore.openErrorModal({
                content:
                    resultOfRequest.data.message ||
                    "Firma transfer işlemi sırasında bir hata oluştu"
            });
            return false;
        }
        appStore.showSuccessMessage({
            content: resultOfRequest.data.message || "Alt firma başarıyla transfer edildi"
        });
        return true;
    };

    @action updateSubCompanyCodPaymentMethodsSelfSelectionFeatureStatus = async params => {
        const resultOfRequest = await companyService.updateSubCompanyCodPaymentMethodsSelfSelectionFeatureStatus(
            params
        );
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action updateSubCompanyCodPaymentMethodsSelfSelection = async params => {
        const resultOfRequest = await companyService.updateSubCompanyCodPaymentMethodsSelfSelection(
            params
        );
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action getSubcompanyCodPaymentList = async params => {
        const resultOfRequest = await companyService.getSubcompanyCodPaymentList(params);
        console.log("ResultOfRequest: ", resultOfRequest);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };
}

export default new companyStore();
